import styled from "styled-components";
import React from "react";

import Stars from "Components/Stars";
import HomeProvider from "Provider/HomeProvider";

import PageWrapper from "Components/PageWrapper";
import usePlanetData from "Hooks/usePlanetData";
import HomeView from "Components/HomeView";

// STYLED
const Wrapper = styled(PageWrapper)<{ active: boolean }>`
	position: relative;
	padding: 0;
	opacity: ${(props) => (props.active ? 1 : 0)};
	transition: ${(props) => props.theme.transition.default};
	transition-property: opacity;
	overflow: hidden;
`;

const Home: React.FC = () => {
	const { data } = usePlanetData();

	return (
		<Wrapper active={true}>
			{/* HOME */}
			<HomeProvider>
				<Stars count={30} />

				{data !== undefined && <HomeView data={data} />}
			</HomeProvider>
		</Wrapper>
	);
};

export default Home;
